<ng-container *transloco="let t">
  <div class="urine-finding" [formGroup]="form">
    <div class="grid grid-cols-2 gap-4">
      <div class="field">
        <label class="label">{{ t('Specific gravity') }}</label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="specificGravity"
            placeholder="{{ t('Enter value') }}"
          />
        </mat-form-field>
      </div>

      <div class="field">
        <label class="label">{{ t('Nitrites') }}</label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="nitrites"
            placeholder="{{ t('Enter value') }}"
          />
        </mat-form-field>
      </div>

      <div class="field">
        <label class="label">{{ t('Ph') }}</label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="pH"
            placeholder="{{ t('Enter value') }}"
          />
        </mat-form-field>
      </div>

      <div class="field">
        <label class="label">{{ t('Proteins') }}</label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="proteins"
            placeholder="{{ t('Enter value') }}"
          />
        </mat-form-field>
      </div>

      <div class="field">
        <label class="label">{{ t('Glucose Blood, erythrocytes.') }}</label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="glucose"
            placeholder="{{ t('Enter value') }}"
          />
        </mat-form-field>
      </div>

      <div class="field">
        <label class="label">{{ t('Urobilinogen') }}</label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="urobilinogen"
            placeholder="{{ t('Enter value') }}"
          />
        </mat-form-field>
      </div>

      <div class="field">
        <label class="label">{{ t('Bilirubin') }}</label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="bilirubin"
            placeholder="{{ t('Enter value') }}"
          />
        </mat-form-field>
      </div>

      <div class="field">
        <label class="label">{{ t('Ketones') }}</label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="ketones"
            placeholder="{{ t('Enter value') }}"
          />
        </mat-form-field>
      </div>

      <div class="field">
        <label class="label">{{ t('Leukocytes') }}</label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="leukocytes"
            placeholder="{{ t('Enter value') }}"
          />
        </mat-form-field>
      </div>

      <div class="field">
        <label class="label">{{ t('Blood, erythrocytes.') }}</label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="erythrocytes"
            placeholder="{{ t('Enter value') }}"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="field">
      <label class="label">{{ t('urine.sediment') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="sediment" rows="4"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('urine.culture') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="culture" rows="4"></textarea>
      </mat-form-field>
    </div>

    <!-- Note field removed to match provided image -->

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
